module.exports = __webpack_public_path__ + "static/9-43fd7199cb20d26fa913668b17e40d72.jpg";